import { 
  LuMap, 
  LuTarget, 
  LuTrendingUp, 
  LuUsers, 
  LuSparkles,
  LuDatabase,
  LuLogIn,
  LuMessageSquare,
  LuShieldCheck
} from "react-icons/lu"
import { useEffect, useState } from "react"
import "./WhatWeDo.css"

function WhatWeDo() {
  const [loaded, setLoaded] = useState(false)

  useEffect(() => {
    setLoaded(true)
  }, [])

  return (
    <section className={`what-section ${loaded ? "loaded" : ""}`}>
      <h2>
        <LuSparkles className="section-icon" /> Platform Does ?
      </h2>

      <div className="what-grid">

        <div className="what-card">
          <LuLogIn className="what-icon" style={{ color: '#3b82f6' }} />
          <h3>Login / Signup First</h3>
          <p>
            Create your account to unlock personalized features. 
            Your journey begins with secure authentication.
          </p>
        </div>

        <div className="what-card">
          <LuTarget className="what-icon" style={{ color: '#22c55e' }} />
          <h3>Select Your Field</h3>
          <p>
            Choose your branch like CSE, IT, ENTC or any other field. 
            Everything becomes customized based on your selection.
          </p>
        </div>

        <div className="what-card">
          <LuMap className="what-icon" style={{ color: '#8b5cf6' }} />
          <h3>Get a Clean Roadmap</h3>
          <p>
            Receive a structured roadmap showing what to learn, 
            what projects to build, and in what sequence.
          </p>
        </div>

        <div className="what-card">
          <LuTrendingUp className="what-icon" style={{ color: '#f97316' }} />
          <h3>Internship & Package Strategy</h3>
          <p>
            We guide you on required CGPA targets, skill expectations, 
            and preparation strategy to secure internships and high packages.
          </p>
        </div>

        <div className="what-card">
          <LuDatabase className="what-icon" style={{ color: '#ef4444' }} />
          <h3>Dynamic Real-Time System</h3>
          <p>
            All roadmap content is fully dynamic and managed via admin panel. 
            Updates happen instantly using our real-time database.
          </p>
        </div>

        <div className="what-card">
          <LuMessageSquare className="what-icon" style={{ color: '#ec4899' }} />
          <h3>Direct Chat with Admin & Teachers</h3>
          <p>
            Ask doubts directly in real-time. You can chat anonymously 
            or with your profile — full privacy control is in your hands.
          </p>
        </div>

        <div className="what-card">
          <LuShieldCheck className="what-icon" style={{ color: '#14b8a6' }} />
          <h3>Security & Privacy Assured</h3>
          <p>
            We ensure complete data security with encrypted authentication, 
            protected databases, and strict privacy controls for every user.
          </p>
        </div>

        <div className="what-card">
          <LuUsers className="what-icon" style={{ color: '#6366f1' }} />
          <h3>Complete Career Clarity</h3>
          <p>
            From first year to placement, we guide you step-by-step 
            so you always know exactly what to do next.
          </p>
        </div>

      </div>
    </section>
  )
}

export default WhatWeDo